import styled from "styled-components"

export const FeedDetailListBlock = styled.div`
  position: relative;
  background: #fff;
`

export const FeedDetailContent = styled.div`
  position: relative;
  min-height: calc(100vw / (375 / 375));
  width: 100%;
`

export const FeedCotentImg = styled.img`
  image-rendering: -webkit-optimize-contrast;
`

export const FeedTimeBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
  padding: calc(100vw * (7 / 375)) calc(100vw * (12 / 375));
`

export const FeedTimeText = styled.p`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: 1.5;
  color: #ffffff;
`

export const AnimationBlock = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 30;
`
